import { render, staticRenderFns } from "./helpCourse.vue?vue&type=template&id=06ead0b6&scoped=true"
import script from "./helpCourse.vue?vue&type=script&lang=js"
export * from "./helpCourse.vue?vue&type=script&lang=js"
import style0 from "./helpCourse.vue?vue&type=style&index=0&id=06ead0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ead0b6",
  null
  
)

export default component.exports